import Cleave from "cleave.js"
import noUiSlider, {Options} from "nouislider"

// Define the histogram data interface
interface HistogramColumn {
  id: number;
  min: number;
  max: number;
  pocet: number;
}

// Add type declaration for the global function
declare global {
  interface Window {
    updateHistogram: (rangeElement: string | HTMLElement, histogramData: HistogramColumn[]) => void;
  }
}

const ranges = document.querySelectorAll<HTMLElement>(".f-range")
setRanges(ranges);

const targetElements = document.querySelectorAll(".f-range");

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function(mutation) {
    if(mutation.type==="attributes") {
      //const ranges = document.querySelectorAll<HTMLElement>(".f-range")
      const ranges = [<HTMLElement>mutation.target]
      setRanges(ranges);
    }
  })
})
targetElements.forEach(function(targetElement){
  observer.observe(targetElement, {attributes: true});
});

// Function to update histogram data
window.updateHistogram = function(rangeElement: string | HTMLElement, histogramData: HistogramColumn[]) {
  // Get the range element
  let range: HTMLElement;
  if (typeof rangeElement === 'string') {
    const element = document.querySelector(rangeElement);
    if (!element) {
      console.error('Range element not found:', rangeElement);
      return;
    }
    range = element as HTMLElement;
  } else {
    range = rangeElement;
  }

  const histogramContainer = range.querySelector('.f-range__histogram');
  if (!histogramContainer) {
    console.error('Histogram container not found in range element');
    return;
  }

  let maxPocet = 0;
  histogramData.forEach(column => {
    maxPocet = Math.max(maxPocet, column.pocet);
  });

  histogramContainer.innerHTML = '';

  histogramData.forEach((column, index) => {
    const heightPct = maxPocet > 0 ? (column.pocet / maxPocet * 100) : 0;
    const columnElement = document.createElement('div');
    columnElement.className = 'f-range__histogram-column';
    columnElement.style.height = `${heightPct}%`;

    const sliderMinPct = index / histogramData.length * 100;
    const sliderMaxPct = (index + 1) / histogramData.length * 100;

    columnElement.dataset.minPct = sliderMinPct.toString();
    columnElement.dataset.maxPct = sliderMaxPct.toString();

    histogramContainer.appendChild(columnElement);
  });

  const sliderInput = range.querySelector<HTMLElement>('.f-range__slider');
  if (sliderInput && sliderInput.noUiSlider) {
    updateHistogramActiveColumns(sliderInput.noUiSlider, range)
  }
};

function updateHistogramActiveColumns(slider, range) {
    const histogramColumns = range.querySelectorAll(".f-range__histogram-column")
    if (histogramColumns.length > 0) {
        const minPct = slider.getPositions()[0]
        const maxPct = slider.getPositions()[1]

        histogramColumns.forEach(column => {
            if (column.dataset.minPct && column.dataset.maxPct) {
                const columnMinPct = Number(column.dataset.minPct)
                const columnMaxPct = Number(column.dataset.maxPct)

                // Column is active if it overlaps with the selected range (using percentages)
                const isActive = (columnMinPct <= maxPct && columnMaxPct >= minPct)
                column.classList.toggle("active", isActive)
            }
        })
    }
}

function setRanges(ranges) {
  ranges.forEach((range) => {
    const sliderInput = range.querySelector<HTMLElement>(".f-range__slider")

    const {
      min: dataMin = 0,
      max: dataMax = 1,
      minStart: dataMinStart = dataMin,
      maxStart: dataMaxStart = dataMax,
    } = range.dataset

    const min = Number(dataMin)
    const max = Number(dataMax)
    const minStart = Number(dataMinStart)
    const maxStart = Number(dataMaxStart)

    const step = range.getAttribute("data-step") ? Number(range.getAttribute("data-step")) : undefined

    if (!sliderInput) return

    if (sliderInput.noUiSlider) sliderInput.noUiSlider.destroy()

    const rangeOptions: Options = {
      start: [minStart, maxStart],
      range: {
        min: min,
        max: max,
      },
      format: {
        to: function (value) {
          if (value === max) {
            return ""
          }
          return Math.round(value).toLocaleString()
        },
        from: function (value) {
          return Number(value)
        },
      },
      connect: true,
      step: step,
    }

    const slider = noUiSlider.create(sliderInput, rangeOptions)

    const inputMin = range.querySelector<HTMLInputElement>(".f-range__input.--min input")
    const inputMax = range.querySelector<HTMLInputElement>(".f-range__input.--max input")

    if (inputMin !== null && inputMax !== null) {
      const inputs = [inputMin, inputMax]

      slider.on("slide", (values, handle) => {
        inputs[handle].value = String(values[handle])
        updateHistogramActiveColumns(slider, range)
      })

      slider.on("update", (values, handle) => {
        inputs[handle].closest(".f-range__input")?.classList.toggle("--no-suffix", String(values[handle]) === "")
        updateHistogramActiveColumns(slider, range)
      })

      slider.on("change",(values, handle) => {
        const onChangeParameters = range.getAttribute('data-on-change')
        if(onChangeParameters) {
          (onChangeParameters.split(',')).forEach((onChangeParameter) => {
            if (onChangeParameter && typeof window[onChangeParameter] === "function") {
              window[onChangeParameter]()
            }
          })
        }
      })

      inputs.forEach((input) => {
        input.addEventListener("keyup", () => {
          const {value} = input
          const cleanValue = Number(value.replace(/\s/g, ""))
          const steps = slider.steps()

          if (input.closest(".f-range__input")?.classList.contains("--min")) {
            const step = steps[0]
            if (Number(step[1]) > cleanValue) return

            slider.setHandle(0, cleanValue, true, true)
          } else {
            const step = steps[1]

            if (Number(step[1]) > cleanValue) return

            slider.setHandle(1, cleanValue, true, true)
          }
          updateHistogramActiveColumns(slider, range)
        })

        new Cleave(input, {
          delimiter: " ",
          numeral: true,
        })
      })
    }
  })
}
